export { registerSupabaseActions } from "@cogo/runtime-v2"
export type { SupabaseLikeClient, SupabaseActionEngine } from "@cogo/runtime-v2"
